import { api } from "./api";

// Большие скрины с телефона (5-10 МБ) часто обрываются при загрузке в Telegram
// WebView. Ужимаем фото до ~1600px / JPEG 0.82 (<1.5 МБ) — загрузка быстрее и
// стабильнее. PDF и мелкие файлы не трогаем.
const MAX_SIDE = 1600;
const QUALITY = 0.82;
const SKIP_BELOW = 400 * 1024;

export async function compressReceipt(file, opts = {}) {
  const maxSide = opts.maxSide || MAX_SIDE;
  const quality = opts.quality || QUALITY;
  try {
    if (!file || !file.type || !file.type.startsWith("image/")
        || file.type === "image/gif") {
      return file;
    }
    if (file.size <= SKIP_BELOW) return file;
    const url = URL.createObjectURL(file);
    try {
      const img = await new Promise((resolve, reject) => {
        const i = new Image();
        i.onload = () => resolve(i);
        i.onerror = reject;
        i.src = url;
      });
      const scale = Math.min(1, maxSide / Math.max(img.width || 1, img.height || 1));
      const w = Math.max(1, Math.round((img.width || 1) * scale));
      const h = Math.max(1, Math.round((img.height || 1) * scale));
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
      if (!blob || blob.size >= file.size) return file;
      const name = String(file.name || "receipt").replace(/\.[^.]+$/, "") + ".jpg";
      return new File([blob], name, { type: "image/jpeg" });
    } finally {
      URL.revokeObjectURL(url);
    }
  } catch {
    return file;
  }
}

// Повтор POST при сетевом обрыве (Telegram роняет загрузку чека). Безопасно:
// сервер по client_id (или redo_of) обновляет тот же незавершённый заказ,
// а не создаёт дубль.
export async function postFormWithRetry(url, fd, { attempts = 3, onProgress } = {}) {
  let lastErr;
  for (let i = 0; i < attempts; i += 1) {
    try {
      const cfg = onProgress
        ? {
            onUploadProgress: (e) => {
              const total = e.total || 0;
              if (total > 0) {
                onProgress(Math.min(100, Math.round((e.loaded / total) * 100)));
              }
            },
          }
        : undefined;
      return await api.post(url, fd, cfg);
    } catch (e) {
      lastErr = e;
      if (e && e.response) throw e; // сервер ответил — повтор не поможет
      if (i < attempts - 1) {
        await new Promise((r) => setTimeout(r, i === 0 ? 1200 : 3500));
      }
    }
  }
  throw lastErr;
}
